module.exports = __webpack_public_path__ + "static/HP_Latex630_ENG_HORIZ_v1_60fps_test_h264-15e7ef97e41b89f1375ce8c5fe48a05b.mp4";